export enum roles {
  admin = 'admin_demat',
  gestionnaire = 'gestionnaire_demat',
  superviseur = 'superviseur_demat',
}
